import React, { useEffect, useRef, useState } from "react";
import { useRaf } from "rooks";
import { AudioControls } from "../shared/useAudioControls";
import "./StyledSlider.scss";

const MusicController: React.FC<{
  audioControls: AudioControls;
}> = (props): JSX.Element => {
  const [seekActive, setSeekActive] = useState<boolean>(false);
  const seek = useRef<HTMLInputElement>(null);
  const divRef = useRef<HTMLDivElement>(null);

  const setSeekMax = () => {
    if (!seek.current) {
      return;
    }
    seek.current.max = String(Math.floor(props.audioControls.getDuration()));
  };

  const renderSeekPos = () => {
    if (!seek.current) {
      return;
    }
    seek.current.value = String(
      Math.floor(props.audioControls.getCurrentTime())
    );
    updateSliderStyleValue();
    props.audioControls.maybePersistAudioState();
  };

  useRaf(renderSeekPos, seekActive);

  useEffect(() => {
    setSeekActive(props.audioControls.isPlaying());
    setSeekMax();
    renderSeekPos();
  }, [props.audioControls.getPlayerState()]);

  const onSeekChange = () => {
    if (seek.current) {
      props.audioControls.setCurrentTime(Number(seek.current.value));
      updateSliderStyleValue();
    }
  };

  const getSliderInputElement = (): HTMLInputElement | undefined => {
    if (!divRef.current) {
      return;
    }
    const elements = divRef.current.querySelectorAll<HTMLInputElement>(
      'input[type="range"].slider-progress'
    );
    return elements.item(0);
  };

  const updateSliderStyleValue = () => {
    const slider = getSliderInputElement();
    if (!slider) {
      return;
    }
    slider.style.setProperty("--min", slider.min == "" ? "0" : slider.min);
    slider.style.setProperty("--max", slider.max == "" ? "100" : slider.max);
    slider.style.setProperty("--value", slider.value);
  };

  if (props.audioControls.isLoading()) {
    return <div className="ui large active centered inline loader" />;
  }

  return (
    <div
      className="ui three column compact centered grid music-controller"
      ref={divRef}
    >
      <div className="right aligned column">
        <i
          className="link large list icon"
          onClick={props.audioControls.selectCurrentShow}
        />
      </div>
      <div className="center aligned column">
        <i
          className={
            props.audioControls.isPlaying()
              ? "link large pause icon"
              : "link large play icon"
          }
          onClick={props.audioControls.togglePlay}
        />
      </div>
      <div className="left aligned column">
        <i
          className="link large forward icon"
          onClick={props.audioControls.nextTrack}
        />
      </div>
      <div className="two column compact centered row">
        <input
          type="range"
          className="styled-slider slider-progress"
          max="100"
          onChange={onSeekChange}
          onInput={onSeekChange}
          onTouchMove={onSeekChange}
          onTouchEnd={onSeekChange}
          ref={seek}
        />
      </div>
    </div>
  );
};

export default MusicController;
